// extracted by mini-css-extract-plugin
export default {"copyableLinkContainer":"CopyableLink_copyableLinkContainer__AxcAb","copyableLinkInput":"CopyableLink_copyableLinkInput__EIsnP","copyButton":"CopyableLink_copyButton__RYrw4"};